import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import Modal from "./Modal";
import { AuthAPI } from "../../../api/auth-api";

import "./continue-on-device.scss";

const ContinueOnDevice = () => {
  const [showCopied, setShowCopied] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);

  const token = AuthAPI.getToken();
  const loginLink = `${window.location.origin}/home?onboardingToken=${token}`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(loginLink);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
  };

  return (
    <>
      <p className="continue-text">
        <strong>Prefer to continue on another device?{" "}</strong>
        <br />
        <span>
          Scan the{" "}
          <span className="scan-link" onClick={() => setShowQRModal(true)}>
            QR code
          </span>{" "}
          or{" "}
          <span className="copy-link" onClick={handleCopyLink}>
            <span>{showCopied ? "copied!" : "copy this link"}</span>
          </span>{" "}
          to switch.
        </span>
      </p>
      <Modal isOpen={showQRModal} onClose={() => setShowQRModal(false)}>
        <div className="qr-modal-content">
          <h4>Scan QR Code</h4>
          <QRCodeSVG value={loginLink} />
          <button className="primary" onClick={() => setShowQRModal(false)}>
            Close
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ContinueOnDevice; 